import Block from './Block'
import store from '../util/store'
import gsap from 'gsap'

export default class Redirection extends Block {
  getElems() {
    this.arrow = this.el.querySelector('.b-redirection__arrow')
    this.button = this.el.querySelector('.e-button')
    this.blurTopRight = this.el.querySelector('.b-redirection__blur.--top-right')
    this.blurBottomLeft = this.el.querySelector('.b-redirection__blur.--bottom-left')
  }

  init() {
    if (this.blurTopRight || this.blurBottomLeft) {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: this.el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })

      tl.fromTo(this.blurTopRight, {
        yPercent: -25
      }, {
        yPercent: 5
      })

      tl.fromTo(this.blurBottomLeft, {
        yPercent: 25
      }, {
        yPercent: -5
      }, '<')
    }
  }

  events() {
    if (this.arrow && this.button) {
      this.arrow.addEventListener('click', () => {
        const tl = gsap.timeline({
          defaults: {
            ease: 'power3.out',
            duration: 0.1
          },
          onComplete: () => {
            this.button.click()
          }
        })

        tl.to(this.arrow, {
          scale: 0.9
        }).to(this.arrow, {
          scale: 1
        })
      })
    }

    this.el.addEventListener('mouseenter', () => {
      store.cursor.addState('-white')
    })

    this.el.addEventListener('mouseleave', () => {
      store.cursor.removeState('-white')
    })
  }
}
